import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  CircularProgress,
  Card,
  CardContent
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useContentApi from '../api/useContentApi';
import Logo from '../components/Logo';
import { getZodiacSign } from '../services/zodiacService';
import { getZodiacHebrewName } from '../services/zodiacService';
import ZodiacDisplay from '../components/ZodiacDisplay';

const Welcome: React.FC = () => {
  const [welcomeContent, setWelcomeContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const [userZodiac, setUserZodiac] = useState<string>('');
  const [zodiacHebrewName, setZodiacHebrewName] = useState<string>('');
  const { getContentByKey } = useContentApi();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('version 1.0.1');
    
    const fetchWelcomeContent = async () => {
      try {
        setLoading(true);
        const content = await getContentByKey('welcome');
        setWelcomeContent(content.content);

        const userZodiac = getZodiacSign(new Date().toISOString());
        const zodiacHebrewName = getZodiacHebrewName(userZodiac);
        setUserZodiac(userZodiac);
        setZodiacHebrewName(zodiacHebrewName);

        setError('');
      } catch (err) {
        console.error('Failed to fetch welcome content:', err);
        setError('האתר בפעילות תחזוקה. אנא נסו שוב מאוחר יותר.');
      } finally {
        setLoading(false);
      }
    };

    fetchWelcomeContent();
  }, [getContentByKey]);

  const handleContinue = () => {
    navigate('/horoscope');
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Logo />

        <Card elevation={3} sx={{ mb: 5 }}>
          <CardContent sx={{ p: 4 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
              </Box>
            ) : error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-line', textAlign: 'right', fontSize: '1.1rem' }}>
                {welcomeContent}
              </Typography>
            )}
          </CardContent>
        </Card>

        <ZodiacDisplay
          zodiacSign={userZodiac}
          zodiacName={zodiacHebrewName}
          textPrefix="מזל: "
          imageSize={16}
          gap={0}
          direction="column"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          size="large"
          sx={{
            fontSize: '1.2rem',
            padding: '0.75rem 2.5rem',
            mt: 2,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            '&:hover': {
              boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
            }
          }}
        >
          מתחילים
        </Button>
      </Box>
    </Container>
  );
};

export default Welcome; 